export default class FormValidate {

    constructor(fields, lang = 1, formId) {
        this.fields = fields;
        this.lang = lang;
        this.error = false;
        this.errorMessageId = '';
        this.element = null;
        this.formId = formId;
    }

    validateAll() {
        for (const field of this.fields) {
            if (this.hasError()) {
                break;
            }
            this.validateField(field);
        }
    }

    validateField(field) {
        const element = document.querySelector(`#${this.formId} [name="${field.name}"]`);
        this.element = element;
        const value = field.value;

        if (!element || this.fieldIsNotRequired(element) || field.name === '_token') {
            return;
        }

        const fieldName = element.getAttribute('fieldName');
        const fieldType = element.getAttribute('fieldType');
        let fieldIdError = element.getAttribute('idError') || element.getAttribute('name');

        switch (fieldType) {
            case 'email':
                this.error = FormValidate.validateEmail(value);
                this.errorMessageId = fieldIdError;
                break;
            case 'checkbox':
                const checked = FormValidate.validateCheckboxIsChecked(element);
                if (!checked) {
                    this.error = true;
                }
                this.errorMessageId = fieldIdError;
                break;
            case 'phone':
                this.error = FormValidate.validatePhone(value);
                this.errorMessageId = fieldIdError;
                break;
            case 'notNull':
                this.error = FormValidate.validateNotNull(value);
                this.errorMessageId = fieldIdError;
                break;
            case 'name':
                this.error = FormValidate.validateName(value);
                this.errorMessageId = fieldIdError;
                break;
            default:
                this.error = FormValidate.validateNotNull(value);
                this.errorMessageId = fieldIdError;
                break;
        }
    }

    hasError() {
        return this.error;
    }

    getErrorId() {
        return this.errorMessageId || false;
    }

    getElement() {
        return this.element;
    }

    fieldIsNotRequired(element) {
        return element.hasAttribute('notRequired');
    }

    static validateEmail(email) {
        const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
        return !pattern.test(email);
    }

    static validateCheckboxIsChecked(element) {
        return element.checked;
    }

    static validateName(name) {
        const regex = /[0-9]/;
        return regex.test(name) || name.length < 3;
    }

    static validateNotNull(value) {
        return value === '';
    }

    static validatePhone(value) {
        return value === '' || value.length < 14;
    }
}
